"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicPricingInfo = exports.DynamicPricingInfoMetaBlacklistedDate = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_validator_1 = require("class-validator");
class ExtraCoefficientModel {
    vehicleType;
    priceCoefficient;
    feeCoefficient;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.VehicleType),
    __metadata("design:type", Number)
], ExtraCoefficientModel.prototype, "vehicleType", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ExtraCoefficientModel.prototype, "priceCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ExtraCoefficientModel.prototype, "feeCoefficient", void 0);
class DynamicPricingInfoMetaBlacklistedDate {
    _id;
    date;
    parentDescription;
    description;
    countryIds;
    locationIds;
    routeIds;
    geolocations;
    locationRadiusMeters;
    timeRangeCoefficient;
    distanceRangeCoefficient;
    vehicleCoefficients;
    originPolygon;
    destinationPolygon;
}
exports.DynamicPricingInfoMetaBlacklistedDate = DynamicPricingInfoMetaBlacklistedDate;
class DynamicPricingInfoMeta {
    blacklistedDate;
    extraCoefficients;
}
class DynamicPricingInfo {
    vehicleCoefficients;
    date;
    message;
    isBlacklistedDate;
    meta;
}
exports.DynamicPricingInfo = DynamicPricingInfo;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], DynamicPricingInfo.prototype, "vehicleCoefficients", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Date)
], DynamicPricingInfo.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], DynamicPricingInfo.prototype, "message", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], DynamicPricingInfo.prototype, "isBlacklistedDate", void 0);
//# sourceMappingURL=DynamicPricingInfo.js.map